import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  navLinks: [],
  sidebarOpen: false,
  subscriptionFeatures: null,
  subscriptionStatus: 'idle'
};

const uiSlice = createSlice({
  name: 'ui',
  initialState,
  reducers: {
    setNavLinks(state, action) {
      state.navLinks = action.payload;
    },
    setSubscriptionEntitlements(state, action) {
      state.subscriptionFeatures = action.payload?.features || [];
      state.subscriptionStatus = action.payload?.status || 'ACTIVE';
    },
    clearSubscriptionEntitlements(state) {
      state.subscriptionFeatures = null;
      state.subscriptionStatus = 'idle';
    },
    toggleSidebar(state, action) {
      state.sidebarOpen = typeof action.payload === 'boolean' ? action.payload : !state.sidebarOpen;
    }
  }
});

export const { setNavLinks, setSubscriptionEntitlements, clearSubscriptionEntitlements, toggleSidebar } = uiSlice.actions;
export default uiSlice.reducer;
